import React, { memo, useState } from "react";
import { validators } from "investira.sdk";
import {
  Stack,
  Card,
  CardContent,
  ToggleButton,
  ToggleButtonGroup,
} from "investira.react.components";
import DurationChart from "./DurationChart";
import TipoAtivoChart from "./TipoAtivoChart";
import IndexadorChart from "./IndexadorChart";

const Graphs = memo((props) => {
  const { data = [] } = props;

  const [alignment, setAlignment] = useState("duration");

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const xResumo = data.response?.resumo;

  if (validators.isNull(xResumo)) {
    return null;
  }

  return (
    <Stack sx={{ gap: 2 }} component="section">
      <Stack spacing={2}>
        <Card sx={{ height: "100%" }}>
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
              minHeight: "200px",
            }}
          >
            <Stack direction="row">
              <Stack flexGrow={1} alignItems="center" justifyContent="center">
                <ToggleButtonGroup
                  color="primary"
                  value={alignment}
                  exclusive
                  onChange={handleChange}
                >
                  <ToggleButton
                    value="duration"
                    sx={{
                      whiteSpace: "nowrap",
                      padding: "4px 8px",
                      fontSize: "0.75rem",
                    }}
                  >
                    Duration
                  </ToggleButton>
                  <ToggleButton
                    value="ativos"
                    sx={{ padding: "4px 8px", fontSize: "0.75rem" }}
                  >
                    Tipo de Ativos
                  </ToggleButton>
                  <ToggleButton
                    value="indexador"
                    sx={{ padding: "4px 8px", fontSize: "0.75rem" }}
                  >
                    Indexador
                  </ToggleButton>
                </ToggleButtonGroup>
              </Stack>
            </Stack>
            <Stack
              direction={{ xs: "column", md: "row" }}
              sx={{
                flex: 1,
                minHeight: 0, // Importante para flexbox
              }}
              py={1}
            >
              <Stack
                sx={{
                  width: "100%",
                  height: "100%",
                  minHeight: "300px",
                  isolation: "isolate",
                }}
              >
                {alignment === "duration" && (
                  <DurationChart data={xResumo.duration} />
                )}

                {alignment === "ativos" && (
                  <TipoAtivoChart data={xResumo.tipo_de_ativo} />
                )}

                {alignment === "indexador" && (
                  <IndexadorChart data={xResumo.indexadores} />
                )}
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
    </Stack>
  );
});

export default Graphs;
